/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyermotifpromo3Inputs */

const en_checkinflyermotifpromo3 = /** @type {(inputs: Checkinflyermotifpromo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promote`)
};

const de_checkinflyermotifpromo3 = /** @type {(inputs: Checkinflyermotifpromo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerben`)
};

/**
* | output |
* | --- |
* | "Promote" |
*
* @param {Checkinflyermotifpromo3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyermotifpromo3 = /** @type {((inputs?: Checkinflyermotifpromo3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyermotifpromo3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyermotifpromo3(inputs)
	return de_checkinflyermotifpromo3(inputs)
});
export { checkinflyermotifpromo3 as "checkinFlyerMotifPromo" }